import { render, staticRenderFns } from "./MessageAdd.vue?vue&type=template&id=62d5057e"
import script from "./MessageAdd.vue?vue&type=script&lang=js"
export * from "./MessageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports